import VerifyProfile from './VerifyProfile';

export default VerifyProfile;
